module.exports = __webpack_public_path__ + "images/emoji/do_not_litter.2f80dd5617283fb66f27.png";